import { gsap } from 'gsap';
import { useEffect } from 'react';

import { setAnimationToIllustrationsPaths } from '@components/Sections/utils/animations';

import { StyledCup, StyledGlobe, StyledNotGood, StyledNotInterested, StyledWomen } from './IllustrationPens.styled';

export const IllustrationPens: React.FC = () => {
  useEffect(() => {
    const ctx = gsap.context(() => {
      setAnimationToIllustrationsPaths({
        illustration: '.not-good path',
        trigger: '.not-good',
        startPosition: 'bottom 90%',
      });
      setAnimationToIllustrationsPaths({
        illustration: '.not-interested path',
        trigger: '.not-interested',
        startPosition: 'bottom 90%',
        delay: 0.25,
      });
      setAnimationToIllustrationsPaths({
        illustration: '.globe path',
        trigger: '.globe',
        startPosition: 'bottom 90%',
        delay: 0.5,
      });
      setAnimationToIllustrationsPaths({
        illustration: '.women path',
        trigger: '.women',
        startPosition: 'bottom 90%',
      });
      setAnimationToIllustrationsPaths({
        illustration: '.cup path',
        trigger: '.cup',
        startPosition: 'bottom 90%',
        delay: 0.2,
      });
    });

    return () => ctx.revert();
  }, []);

  return (
    <>
      <StyledNotGood className="not-good" aria-label="not (strikethrough) good" />
      <StyledWomen className="women" role="presentation" aria-hidden />
      <StyledCup className="cup" role="presentation" aria-hidden />
      <StyledNotInterested className="not-interested" aria-label="not interested" />
      <StyledGlobe className="globe" role="presentation" aria-hidden />
    </>
  );
};
